import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M84.9 47.2h30.2V17.1H84.9v30.1zm45.3-30.1v30.2h45.2c8.3 0 15.1 6.8 15.1 15.1v30.2c0 7.5-5.5 13.9-13 14.9l10.5 73.4c1.2 8.2-4.6 15.9-12.8 17.1-.7.1-1.4.2-2.1.2H26.9c-8.3 0-15.1-6.8-15.1-15.1 0-.7.1-1.4.2-2.1l10.5-73.4c-7.4-1.1-13-7.4-13-14.9V62.3c0-8.3 6.8-15.1 15.1-15.1h45.2V17.1C69.8 8.8 76.6 2 84.9 2h30.2c8.3 0 15.1 6.8 15.1 15.1zm32.1 75.4h13.1V62.3H24.6v30.2h137.7zm0 15H37.7l-10.8 75.4h27.8v-30.2h15.1v30.2h22.6v-30.2h15.1v30.2h22.6v-30.2h15.1v30.2H173l-10.7-75.4z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}